import PackageProcessIconSolid from '@/components/icons/PackageProcessIconSolid';
import PackageOpenIconSolid from '@/components/icons/PackageOpenIconSolid';
import PackageMovingIconSolid from '@/components/icons/PackageMovingIconSolid';
import PackageDeliveredIconSolid from '@/components/icons/PackageDeliveredIconSolid';
import PackageRemoveIconSolid from '@/components/icons/PackageRemoveIconSolid';
import { OrderStatus } from '@/features/orders/types/orders-dto';
import { t } from 'i18next';

const getStatusData = (status: OrderStatus) => {
	switch (status) {
		case OrderStatus.Draft:
			return {
				label: t('main.orders.status.draft'),
				icon: PackageProcessIconSolid,
				iconStyles: 'fill-popover-1000',
				colorClass: 'bg-popover-100 fill-popover-1000',
			};
		case OrderStatus.PendingPayment:
			return {
				label: t('main.orders.status.pendingPayment'),
				icon: PackageProcessIconSolid,
				iconStyles: 'fill-popover-1000',
				colorClass: 'bg-popover-100 fill-popover-1000',
			};
		case OrderStatus.PendingConfirmation:
			return {
				label: t('main.orders.status.pendingConfirmation'),
				icon: PackageOpenIconSolid,
				iconStyles: 'fill-info-1000',
				colorClass: 'bg-popover-100 fill-info-1000',
			};
		case OrderStatus.InProgress:
			return {
				label: t('main.orders.status.inProgress'),
				icon: PackageMovingIconSolid,
				iconStyles: 'fill-warning-1000',
				colorClass: 'bg-popover-100 fill-warning-1000',			
			};
		case OrderStatus.Ordered:
			return {
				label: t('main.orders.status.ordered'),
				icon: PackageOpenIconSolid,
				iconStyles: 'fill-info-1000',
				colorClass: 'bg-popover-100 fill-info-1000',
			};
		case OrderStatus.Completed:
			return {
				label: t('main.orders.status.completed'),
				icon: PackageDeliveredIconSolid,
				iconStyles: 'fill-success-1000',
				colorClass: 'bg-popover-100 fill-success-1000',
			};
		case OrderStatus.Canceled:
			return {
				label: t('main.orders.status.canceled'),
				icon: PackageRemoveIconSolid,
				iconStyles: 'fill-error-1000',
				colorClass: 'bg-popover-100 fill-error-1000',
			};
		case OrderStatus.Rejected:
			return {
				label: t('main.orders.status.rejected'),
				icon: PackageRemoveIconSolid,
				iconStyles: 'fill-error-1000',
				colorClass: 'bg-popover-100 fill-error-1000',
			};
	}
};

const getStepsToShow = (status: OrderStatus) => {
	if (
		status === OrderStatus.Draft ||
		status === OrderStatus.PendingPayment ||
		status === OrderStatus.PendingConfirmation
	) {
		return [status, OrderStatus.InProgress, OrderStatus.Completed];
	}

	if (status === OrderStatus.Canceled || status === OrderStatus.Rejected) {
		return [OrderStatus.Ordered, OrderStatus.InProgress, status];
	}

	return [OrderStatus.Ordered, OrderStatus.InProgress, OrderStatus.Completed];
};

const getMinMaxValues = (range?: string | null) => {
  const normalizedRange = range?.replace('+', '-') ?? '';
  const [min = '', max = ''] = normalizedRange.split('-');
  return { min, max };
};

export const ordersUtils = {
	getStatusData,
	getStepsToShow,
	getMinMaxValues
};
